import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbOfferGridBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`offer-grid ${props.attributes.className ? props.attributes.className : ''} ${classes.offerGrid}`}>
        {blocks.map((block) => {
            return block;
        })}
    </div>
};

export const CgbOfferGridBlockFragment = graphql`
  fragment CgbOfferGridBlock on WpBlock {
    ... on WpCgbOfferGridBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbOfferGridBlockPreview = `
    ... on CgbOfferGridBlock {
        name
        attributes {
            className
        }
    }
`;